import React from "react";

export default function Header() {
  return <h1 className="nameApp">Weather app</h1>;
}
